import React, { useState, useEffect, useRef } from 'react'
import { FileTextOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, List, Modal, Input, DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getTerminationUrl } from 'states/modules/documentDetail'
import { number, object } from 'prop-types'
import PdfCarouselModal from '~/components/PdfCarouselModal'
import FileUpload from '~/components/fileUpload'
import api from 'services/api'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'

const TerminationView = ({ document_id, termination }) => {
	const dispatch = useDispatch()
	const terminationUrls = useSelector(
		(state) => state.documentDetail.terminationUrls.data
	)
	const loadingTermination = useSelector(
		(state) => state.documentDetail.terminationUrls.loading
	)
	const history = useHistory()
	const isMountedRef = useRef(true)

	useEffect(() => {
		return () => {
			isMountedRef.current = false
		}
	}, [])

	const [visible, setVisible] = useState(false)
	const [currentIndex, setCurrentIndex] = useState(0)
	const [addModalVisible, setAddModalVisible] = useState(false)
	const [newTerminationName, setNewTerminationName] = useState('')
	const [newTerminationDate, setNewTerminationDate] = useState(null)
	const [uploadedFile, setUploadedFile] = useState(null)
	const [uploading, setUploading] = useState(false)

	const hasTermination = termination && termination.filename
	const terminationList = hasTermination ? [termination] : []

	const openModal = (index) => {
		dispatch(getTerminationUrl({ id: document_id }))
		setCurrentIndex(index)
		setVisible(true)
	}

	const openAddModal = () => {
		resetTerminationForm()
		setAddModalVisible(true)
	}

	const resetTerminationForm = () => {
		setNewTerminationName('')
		setNewTerminationDate(null)
		setUploadedFile(null)
		setUploading(false)
	}

	const handleFileChange = (files) => {
		if (files && files.length > 0) {
			setUploadedFile(files[0])
			setUploading(false)
		} else {
			setUploadedFile(null)
		}
	}

	const handleAddTermination = async () => {
		if (!uploadedFile || !newTerminationName || !newTerminationDate) return

		const payload = {
			name: newTerminationName,
			filename: uploadedFile.name,
			date: dayjs(newTerminationDate).format('DD/MM/YYYY'),
			uuid: uploadedFile.uid,
		}

		try {
			setUploading(true)
			await api.post(`/documents/${document_id}/add-termination`, payload)
			if (isMountedRef.current) {
				setAddModalVisible(false)
				resetTerminationForm()
				history.push(`/documents/${document_id}/edit`)
			}
		} catch (error) {
			console.error('Erro ao adicionar distrato', error)
		} finally {
			if (isMountedRef.current) {
				setUploading(false)
			}
		}
	}

	const isAddButtonDisabled =
		!newTerminationName || !newTerminationDate || !uploadedFile

	return (
		<div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<h3>Distrato</h3>
				<Button type="primary" icon={<PlusOutlined />} onClick={openAddModal}>
					Adicionar
				</Button>
			</div>

			{terminationList.length === 0 ? (
				<div style={{ textAlign: 'center', padding: '40px 0' }}>
					<FileTextOutlined style={{ fontSize: 40, color: '#ccc' }} />
					<p style={{ marginTop: 10, color: '#999' }}>
						Este documento ainda não possui distrato.
					</p>
				</div>
			) : (
				<>
					<List
						itemLayout="horizontal"
						dataSource={terminationList}
						locale={{ emptyText: 'Nenhum distrato disponível.' }}
						renderItem={(item, index) => (
							<List.Item
								onClick={() => openModal(index)}
								style={{ cursor: 'pointer' }}>
								<List.Item.Meta
									avatar={<FileTextOutlined style={{ fontSize: '20px' }} />}
									title={item.name}
									description={item.data}
								/>
							</List.Item>
						)}
					/>

					<PdfCarouselModal
						isVisible={visible}
						onClose={() => setVisible(false)}
						documents={terminationList}
						urls={terminationUrls}
						loading={loadingTermination}
						initialIndex={currentIndex}
						title="Distrato"
					/>
				</>
			)}

			<Modal
				title="Adicionar Distrato"
				open={addModalVisible}
				onCancel={() => setAddModalVisible(false)}
				onOk={handleAddTermination}
				okText="Adicionar"
				cancelText="Cancelar"
				okButtonProps={{
					disabled: isAddButtonDisabled || uploading,
					loading: uploading,
				}}>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
					<Input
						placeholder="Nome do Distrato"
						value={newTerminationName}
						onChange={(e) => setNewTerminationName(e.target.value)}
					/>
					<DatePicker
						style={{ width: '100%' }}
						placeholder="Data"
						format="DD/MM/YYYY"
						value={newTerminationDate}
						onChange={(date) => setNewTerminationDate(date)}
					/>
					<FileUpload
						onChange={handleFileChange}
						multiple={false}
						folder="terminations"
					/>
				</div>
			</Modal>
		</div>
	)
}

TerminationView.propTypes = {
	termination: object,
	document_id: number,
}

export default TerminationView
